let config = {
  $websiteName: "DXT360 Essential",
  $websiteDescription: "A Dashboard website for DXT360 Essential",
  $dev_base_url: window.location.origin, //use in development - ignore by engineer
  $demo_base_url: window.location.origin, //use in development - ignore by engineer

  // //$dev_api_url: "iqio-webapi/index.php",
  // $dev_api_url: "IQIO_WebAPI/branches/20220531_v.2.2.31.23/IQIO/index.php", //use in development - ignore by engineer
  // //$api_url: "public/index.php",
  // $api_url: "IQIO/index.php",

  $dev_api_url: "iqio-webapi-essential/index.php",
  $api_url: "IQIO/index.php",

  $is_production: true, //true = use production env; false = use dev env
  $is_demo: 0,
  //0 = R1 - without choose customer,
  //1 = Demo - with choose customer, summary, report and cleansing,
  //2 = C1 - with choose customer
  
  //00b400
  // $colorScheme: ["#FFE049", "#D2AE00", "#FF9B49", "#D25F00"],
  // $colorScheme1: ["#051F5A", "#8AA4E2"],
  $colorScheme: ["#001b39", "#7584FF", "#00b400", "#A7DB98"],
  $colorScheme1: ["#00b400", "#A7DB98"],

  $speedVerifyCleansing: 500,

  $latest_update: "2024-08-15",
  $version: "1.2.5",

  // Must match essential-api/config/data.json — used only to unwrap readConfig.
  $configTransportKey: "7c4a8d09ca3762af61e59520943dc264",
  $configTransportIV: "3f8e2b1a9c6d0475e0af1832b9d46c7e"
};

export default {
  config
};